import {Injectable} from '@angular/core';
import {ApiService} from './api.service';
import {map} from 'rxjs/operators';

const routes = {
  // api create export report
  exportTotalContract: '/process-underground-statistic-report/create/total',
  exportTotalSmsQuantity: '/process-underground-statistic-report/create/total',
  exportTotalSmsMoney: '/process-underground-statistic-report/create/total',
  exportContractEnterpriseCreate: '/process-underground-statistic-report/create/contract-enterprise-create',
  exportContractByUserCreate: '/process-underground-statistic-report/create/summary-of-contract-by-user',
  exportContractPersonalCreate: '/process-underground-statistic-report/create/contract-personal-create',
  exportContractEnterpriseReceive: '/process-underground-statistic-report/create/contract-enterprise-receive',
  exportEndorsementMoney: '/process-underground-statistic-report/create/endorsement-money',
  exportTimestampQuantity: '/process-underground-statistic-report/create/numbers-of-timestamp',
  exportProcessingContract: '/process-underground-statistic-report/create/contract-processing',
  exportSmsHistoryReport: '/process-underground-statistic-report/create/sms-history-report',

  // api get list report exported history
  filterTotalContract: (type) => `/process-underground-statistic-report/filter/total/${type}`,
  filterPersonalContract: '/process-underground-statistic-report/filter/contract-personal-create',
  filterEnterpriseContract: '/process-underground-statistic-report/filter/contract-enterprise-create',
  filterEnterpriseReceive: '/process-underground-statistic-report/filter/contract-enterprise-receive',
  filterEndorsementMoney: '/process-underground-statistic-report/filter/endorsement-money',
  filterTimestampQuantity: '/process-underground-statistic-report/filter/numbers-of-timestamp',
  filterProcessingContract: '/process-underground-statistic-report/filter/contract-process',
  filterSmsHistoryReport: '/process-underground-statistic-report/filter/sms-history-report',

  // api delete export history by id
  deleteTotalContract: (type, id) => `/process-underground-statistic-report/delete-by-id/total/${type}/${id}`,
  deletePersonalContract: (id) => `/process-underground-statistic-report/delete-by-id/contract-personal-create/${id}`,
  deleteEnterpriseContract: (id) => `/process-underground-statistic-report/delete-by-id/contract-enterprise-create/${id}`,
  deleteEnterpriseReceive: (id) => `/process-underground-statistic-report/delete-by-id/contract-enterprise-receive/${id}`,
  deleteEndorsementMoney: (id) => `/process-underground-statistic-report/delete-by-id/endorsement-money/${id}`,
  deleteTimestampQuantity: (id) => `/process-underground-statistic-report/delete-by-id/numbers-of-timestamp/${id}`,
  deleteProcessingContract: (id) => `/process-underground-statistic-report/delete-by-id/contract-process/${id}`,
  deleteSmsHistoryReport: (id) => `/process-underground-statistic-report/delete-by-id/sms-history-report/${id}`,

  //api download report
  downloadTotalReport: (type, id) => `/process-underground-statistic-report/download-excel/total/${type}/${id}`,
  downloadPersonalContractReport: (id) => `/process-underground-statistic-report/download-excel/contract-personal-create/${id}`,
  downloadEnterpriseContractReport: (id) => `/process-underground-statistic-report/download-excel/contract-enterprise-create/${id}`,
  downloadEnterpriseReceiveReport: (id) => `/process-underground-statistic-report/download-excel/contract-enterprise-receive/${id}`,
  downloadEndorsementMoney: (id) => `/process-underground-statistic-report/download-excel/endorsement-money/${id}`,
  downloadTimestampQuantity: (id) => `/process-underground-statistic-report/download-excel/numbers-of-timestamp/${id}`,
  downloadProcessingContractReport: (id) => `/process-underground-statistic-report/download-excel/contract-process/${id}`,
  downloadSmsHistoryReport: (id) => `/process-underground-statistic-report/download-excel/sms-history-report/${id}`,

  // api view filter exported
  viewTotalReport: (type, id) => `/process-underground-statistic-report/get-by-id/total/${type}/${id}`,
  viewPersonalContractReport: (id) => `/process-underground-statistic-report/get-by-id/contract-personal-create/${id}`,
  viewEnterpriseContractReport: (id) => `/process-underground-statistic-report/get-by-id/contract-enterprise-create/${id}`,
  viewEnterpriseReceiveReport: (id) => `/process-underground-statistic-report/get-by-id/contract-enterprise-receive/${id}`,
  viewEndorsementMoneyReport: (id) => `/process-underground-statistic-report/get-by-id/endorsement-money/${id}`,
  viewTimestampQuantityReport: (id) => `/process-underground-statistic-report/get-by-id/numbers-of-timestamp/${id}`,
  viewProcessingContractReport: (id) => `/process-underground-statistic-report/get-by-id/contract-process/${id}`,
};

@Injectable({
  providedIn: 'root'
})

export class ReportService {
  constructor(private apiService: ApiService) {
  }

  exportTotalContract(filter: any, type: any) {
    const body = {
      type: type,
      totalReportSearch: filter
    }
    return this.apiService.post( routes.exportTotalContract, body).pipe(
      map(rs => {
        return rs;
      })
    );
  }

  exportTotalSmsQuantity(filter: any) {
    return this.apiService.post( routes.exportTotalSmsQuantity, filter).pipe(
      map(rs => {
        return rs;
      })
    );
  }

  exportTotalSmsMoney(filter: any) {
    return this.apiService.post( routes.exportTotalSmsMoney, filter).pipe(
      map(rs => {
        return rs;
      })
    );
  }

  exportEndorsementMoney(filter: any) {
    const body = {
      totalReportSearch: filter
    }
    return this.apiService.post( routes.exportEndorsementMoney, body).pipe(
      map(rs => {
        return rs;
      })
    );
  }

  exportTimestampQuantity(filter: any) {
    const body = {
      totalReportSearch: filter
    }
    return this.apiService.post( routes.exportTimestampQuantity, body).pipe(
      map(rs => {
        return rs;
      })
    );
  }

  exportContractEnterpriseCreateQuantity(filter: any) {
    const copyFilter = JSON.parse(JSON.stringify(filter));
    const arr = ['status', 'serviceTypeId', 'departmentIds', 'createdUserId', 'customerId', 'templateIds'];
    for (const property of arr) {
      if (copyFilter[property] && copyFilter[property].length === 1 && copyFilter[property][0] === -1) { copyFilter[property] = []; }

      //remove element null, -1, undefined
      if (copyFilter[property] && copyFilter[property].length > 1 && copyFilter[property][0] === -1) {
        copyFilter[property] = copyFilter[property].filter(function (el) {
            return el !== null && el !== -1 && el !== undefined;
        });
      }
    }
    return this.apiService.post( routes.exportContractEnterpriseCreate, copyFilter).pipe(
      map(rs => {
        return rs;
      })
    );
  }

  exportContractByUserCreate(filter: any) {
    const copyFilter = JSON.parse(JSON.stringify(filter));
    const arr = ['status', 'serviceTypeId', 'departmentIds', 'createdUserId', 'customerId', 'templateIds'];
    for (const property of arr) {
      if (copyFilter[property] && copyFilter[property].length === 1 && copyFilter[property][0] === -1) { copyFilter[property] = []; }

      //remove element null, -1, undefined
      if (copyFilter[property] && copyFilter[property].length > 1 && copyFilter[property][0] === -1) {
        copyFilter[property] = copyFilter[property].filter(function (el) {
          return el !== null && el !== -1 && el !== undefined;
        });
      }
    }
    return this.apiService.post( routes.exportContractByUserCreate, copyFilter).pipe(
      map(rs => {
        return rs;
      })
    );
  }

  exportContractPersonalCreateQuantity(filter: any) {
    const copyFilter = JSON.parse(JSON.stringify(filter));
    const arr = ['status', 'serviceTypeId', 'customerId', 'templateIds'];
    for (const property of arr) {
      if (copyFilter[property] && copyFilter[property].length === 1 && copyFilter[property][0] === -1) { copyFilter[property] = []; }

      //remove element null, -1, undefined
      if (copyFilter[property] && copyFilter[property].length > 1 && copyFilter[property][0] === -1) {
        copyFilter[property] = copyFilter[property].filter(function (el) {
            return el !== null && el !== -1 && el !== undefined;
        });
      }
    }
    return this.apiService.postUpload2( routes.exportContractPersonalCreate, copyFilter).pipe(
      map(rs => {
        return rs;
      })
    );
  }

  exportContractEnterpriseReceiveQuantity(filter: any) {
    const copyFilter = JSON.parse(JSON.stringify(filter));
    // missing params
    const arr = ['status', 'contractEnterpriseStatus', 'customerId'];
    for (const property of arr) {
      if (copyFilter[property] && copyFilter[property].length === 1 && copyFilter[property][0] === -1) { copyFilter[property] = []; }

      //remove element null, -1, undefined
      if (copyFilter[property] && copyFilter[property].length > 1 && copyFilter[property][0] === -1) {
        copyFilter[property] = copyFilter[property].filter(function (el) {
            return el !== null && el !== -1 && el !== undefined;
        });
      }
    }
    return this.apiService.post( routes.exportContractEnterpriseReceive, copyFilter).pipe(
      map(rs => {
        return rs;
      })
    );
  }

  exportProcessingContract(filter: any) {
    const copyFilter = JSON.parse(JSON.stringify(filter));
    const arr = ['contractCode', 'contractName', 'phone', 'status', 'receivedAt', 'userName', 'email', 'serviceType', 'templateIds'];
    for (const property of arr) {
      if (copyFilter[property] && copyFilter[property].length === 1 && copyFilter[property][0] === -1) { copyFilter[property] = []; }

      //remove element null, -1, undefined
      if (copyFilter[property] && copyFilter[property].length > 1 && copyFilter[property][0] === -1) {
        copyFilter[property] = copyFilter[property].filter(function (el) {
          return el !== null && el !== -1 && el !== undefined;
        });
      }
    }
    return this.apiService.post( routes.exportProcessingContract, copyFilter).pipe(
      map(rs => {
        return rs;
      })
    );
  }

  filterTotalContract(type: any, filter: any) {
    return this.apiService.post(routes.filterTotalContract(type), filter).pipe(map(res => {
      return res;
    }));
  }

  filterPersonalContract(filter: any) {
    return this.apiService.postFilter(routes.filterPersonalContract, filter).pipe(map(res => {
      return res;
    }));
  }

  filterEnterpriseContract(filter: any) {
    return this.apiService.post(routes.filterEnterpriseContract, filter).pipe(map(res => {
      return res;
    }));
  }

  filterEnterpriseReceive(filter: any) {
    return this.apiService.post(routes.filterEnterpriseReceive, filter).pipe(map(res => {
      return res;
    }));
  }

  filterEndorsementMoney(filter: any) {
    return this.apiService.post(routes.filterEndorsementMoney, filter).pipe(map(res => {
      return res;
    }));
  }

  filterTimestampQuantity(filter: any) {
    return this.apiService.post(routes.filterTimestampQuantity, filter).pipe(map(res => {
      return res;
    }));
  }

  filterProcessingContract(filter: any) {
    return this.apiService.post(routes.filterProcessingContract, filter).pipe(map(res => {
      return res;
    }));
  }

  deleteTotalContract(type: any, id: any) {
    return this.apiService.get(routes.deleteTotalContract(type, id)).pipe(map(res => {
      return res;
    }));
  }

  deletePersonalContract(id: any) {
    return this.apiService.get(routes.deletePersonalContract(id)).pipe(map(res => {
      return res;
    }));
  }

  deleteEnterpriseContract(id: any) {
    return this.apiService.get(routes.deleteEnterpriseContract(id)).pipe(map(res => {
      return res;
    }));
  }

  deleteEnterpriseReceive(id: any) {
    return this.apiService.get(routes.deleteEnterpriseReceive(id)).pipe(map(res => {
      return res;
    }));
  }

  deleteEndorsementMoney(id: any) {
    return this.apiService.get(routes.deleteEndorsementMoney(id)).pipe(map(res => {
      return res;
    }));
  }

  deleteTimestampQuantity(id: any) {
    return this.apiService.get(routes.deleteTimestampQuantity(id)).pipe(map(res => {
      return res;
    }));
  }

  deleteProcessingContract(id: any) {
    return this.apiService.get(routes.deleteProcessingContract(id)).pipe(map(res => {
      return res;
    }));
  }

  downloadTotalContract(type: any, id: any) {
    return this.apiService.getFile(routes.downloadTotalReport(type, id)).pipe(map(res => {
      return res;
    }));
  }

  downloadPersonalContract(id: any) {
    return this.apiService.getFile(routes.downloadPersonalContractReport(id)).pipe(map(res => {
      return res;
    }));
  }

  downloadEnterpriseContract(id: any) {
    return this.apiService.getFile(routes.downloadEnterpriseContractReport(id)).pipe(map(res => {
      return res;
    }));
  }

  downloadEnterpriseReceive(id: any) {
    return this.apiService.getFile(routes.downloadEnterpriseReceiveReport(id)).pipe(map(res => {
      return res;
    }));
  }

  downloadEndorsementMoney(id: any) {
    return this.apiService.getFile(routes.downloadEndorsementMoney(id)).pipe(map(res => {
      return res;
    }));
  }

  downloadTimestampQuantity(id: any) {
    return this.apiService.getFile(routes.downloadTimestampQuantity(id)).pipe(map(res => {
      return res;
    }));
  }

  downloadProcessingContract(id: any) {
    return this.apiService.getFile(routes.downloadProcessingContractReport(id)).pipe(map(res => {
      return res;
    }));
  }

  checkDownloadTotalContract(type: any, id: any) {
    return this.apiService.get(routes.downloadTotalReport(type, id)).pipe(map(res => {
      return res;
    }));
  }

  checkDownloadPersonalContract(id: any) {
    return this.apiService.get(routes.downloadPersonalContractReport(id)).pipe(map(res => {
      return res;
    }));
  }

  checkDownloadEnterpriseContract(id: any) {
    return this.apiService.get(routes.downloadEnterpriseContractReport(id)).pipe(map(res => {
      return res;
    }));
  }

  checkDownloadEnterpriseReceive(id: any) {
    return this.apiService.get(routes.downloadEnterpriseReceiveReport(id)).pipe(map(res => {
      return res;
    }));
  }

  checkDownloadEndorsementMoney(id: any) {
    return this.apiService.get(routes.downloadEndorsementMoney(id)).pipe(map(res => {
      console.log(res);

      return res;
    }));
  }

  checkDownloadTimestampQuantity(id: any) {
    return this.apiService.get(routes.downloadTimestampQuantity(id)).pipe(map(res => {
      return res;
    }));
  }

  checkDownloadProcessingContract(id: any) {
    return this.apiService.get(routes.downloadProcessingContractReport(id)).pipe(map(res => {
      return res;
    }));
  }

  viewTotalContract(type: any, id: any) {
    return this.apiService.get(routes.viewTotalReport(type, id)).pipe(map(res => {
      return res;
    }));
  }

  viewPersonalContract(id: any) {
    return this.apiService.get(routes.viewPersonalContractReport(id)).pipe(map(res => {
      return res;
    }));
  }

  viewEnterpriseContract(id: any) {
    return this.apiService.get(routes.viewEnterpriseContractReport(id)).pipe(map(res => {
      return res;
    }));
  }

  viewEnterpriseReceive(id: any) {
    return this.apiService.get(routes.viewEnterpriseReceiveReport(id)).pipe(map(res => {
      return res;
    }));
  }

  viewEndorsementMoney(id: any) {
    return this.apiService.get(routes.viewEndorsementMoneyReport(id)).pipe(map(res => {
      return res;
    }));
  }

  viewTimestampQuantity(id: any) {
    return this.apiService.get(routes.viewTimestampQuantityReport(id)).pipe(map(res => {
      return res;
    }));
  }

  viewProcessingContractReport(id: any) {
    return this.apiService.get(routes.viewProcessingContractReport(id)).pipe(map(res => {
      return res;
    }));
  }

  exportSmsHistoryReport(filter: any) {
    const body = {
      totalReportSearch: filter
    }
    return this.apiService.post(routes.exportSmsHistoryReport, body).pipe(
      map(rs => {
        return rs;
      })
    );
  }

  filterSmsHistoryReport(filter: any) {
    return this.apiService.postFilter(routes.filterSmsHistoryReport, filter).pipe(map(res => {
      return res;
    }));
  }

  deleteSmsHistoryReport(id: any) {
    return this.apiService.get(routes.deleteSmsHistoryReport(id)).pipe(map(res => {
      return res;
    }));
  }

  downloadSmsHistoryReport(id: any) {
    return this.apiService.getFile(routes.downloadSmsHistoryReport(id)).pipe(map(res => {
      return res;
    }));
  }

  checkDownloadSmsHistoryReport(id: any) {
    return this.apiService.get(routes.downloadSmsHistoryReport(id)).pipe(map(res => {
      return res;
    }));
  }

  viewSmsHistoryReport(id: any) {
    return;
  }
}
